import { render, staticRenderFns } from "./ChatsRows.vue?vue&type=template&id=9b69bd36&"
import script from "./ChatsRows.vue?vue&type=script&lang=ts&"
export * from "./ChatsRows.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports